import axios, { AxiosRequestConfig, AxiosResponse, Method } from 'axios'

let pendingRequest: object = {}

/** Makes a request that cancels pending request of the same seed  */
export const getUnique = (url: string, config: AxiosRequestConfig = {}, seed: string = 'unamed'): Promise<AxiosResponse<any>> => {
  if (pendingRequest[seed]) {
    pendingRequest[seed].cancel("Only one request allowed at a time.")
  }

  pendingRequest[seed] = axios.CancelToken.source()

  config['cancelToken'] = pendingRequest[seed].token
  config['method'] = 'get'
  config['url'] = url

  return axios.request(config)
}

export function isRequestCanceled(err: any) {
  return axios.isCancel(err) || err?.code === "ERR_CANCELED";
}
